import React, { useEffect } from 'react'
import { InfoCDR } from '@verifier-user/verifier-cdr'
import { useApplicationContext } from '../../contexts/appContext'

export const BavCancel = () => {
  const { expire } = useApplicationContext()
  useEffect(() => {
    expire()
  }, [])

  return (
    <>
      <h2 className={'text-4xl sm:text-5xl mb-8 leading-tight'}>Your Bank Account Verification has been cancelled.</h2>

      <InfoCDR
        accreditationLink={process.env.ACCREDITATION_LINK}
        accreditationNumber={process.env.ACCREDITATION_NUMBER}
        companyName={process.env.COMPANY}
      ></InfoCDR>
    </>
  )
}
